import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import QueryBuilder from '../QueryBuilder'
import QueryHeader from './QueryHeader'
import {
  findRule,
  areMultipleDescriptionsSelected,
  isParentValueSelected,
  controlElements
} from '../../utils/portal-query-builder'
import { createAlert } from '../../actions/app-actions'
import { addCustomModal } from '../../actions/modal-actions'
import CopyToClipboardModal from '../../components/Modals/CopyToClipboardModal'
import { permissions as PERMISSIONS } from '../../constants/constants'
import { controlClassnames, fields, getOperators, combinators } from './config'
import {
  fetchTypeChildren,
  handleQueryTreeChanged,
  clearQueryTree,
  createMultipleRules
} from '../../actions/supra-qc-tool-actions.js'
import UserService from '../../services/user-service'
import '../../utils/portal-query-builder/index.scss'
import './style.scss'

import { supraQCToolApplyQuerySamplingQC } from './actions'

class QueryBuilderTree extends Component {
  componentDidUpdate(prevProps) {
    if (prevProps.querySQLLoading === true && this.props.querySQLLoading === false && this.props.querySQL) {
      this.openCopyModal(this.props.querySQL)
    }
  }

  openCopyModal = sql => {
    this.props.addCustomModal({
      modalType: 'successModal',
      id: 'copy-to-clipboard-modal',
      className: 'textarea-modal',
      title: 'Query SQL',
      content: (
        <CopyToClipboardModal
          note="Note: Rules with contains, not contains, contains (stem) and not contains (stem) have been evaluated as if they are wildcard rules."
          text={sql}
          onCopy={this.onCopy}
        />
      )
    })
  }

  applyQueryAndHideTree = () => {
    this.props.toggleTreeVisibility()
    this.props.supraQCToolApplyQuerySamplingQC({
      sessionId: this.props.sessionId,
      queryTree: this.props.queryTree
    })
  }

  applyAndSave = () => {
    if (this.queryHeader) {
      this.queryHeader.saveSearchQuery()
      this.props.supraQCToolApplyQuerySamplingQC({
        sessionId: this.props.sessionId,
        queryTree: this.props.queryTree
      })
    }
  }

  onCopy = (text, result) => {
    const type = result ? 'info' : 'danger'
    const title = result ? 'SQL copied to clipboard' : 'There was an error trying to copy the SQL'
    this.props.createAlert(type, '', title)
  }

  render() {
    const onQueryChange = (query, event, ...actionArgs) => {
      if (areMultipleDescriptionsSelected(event, actionArgs)) {
        // when event == 'onPropChange'
        // actionArgs == [propName, propValue, ruleId]
        const ruleId = actionArgs[2]
        const rule = findRule(ruleId, query)
        this.props.createMultipleRules(rule.value.action, ruleId, rule.value.value)
      } else if (isParentValueSelected(event, actionArgs)) {
        // when event == 'onPropChange'
        // actionArgs == [propName, propValue, ruleId]
        const ruleId = actionArgs[2]
        const rule = findRule(ruleId, query)
        this.props.fetchTypeChildren(rule.field, rule.value, rule.id)
      } else {
        this.props.handleQueryTreeChanged(query, event, actionArgs)
      }
    }
    return (
      <>
        {this.props.isQueryInteractionPermitted && (
          <QueryHeader
            ref={ref => {
              if (ref) {
                this.queryHeader = ref
              }
            }}
            ruleGroupsCountChange={this.props.ruleGroupsCountChange}
          />
        )}

        <QueryBuilder
          fields={fields}
          combinators={combinators}
          getOperators={getOperators}
          query={this.props.queryTree}
          onQueryChange={onQueryChange}
          controlClassnames={controlClassnames}
          controlElements={controlElements}
          onClearQueryTree={this.props.clearQueryTree}
          showQuerySQLModal={() => this.showQuerySQLModal(this.props.queryTree)}
          ruleGroupsCountChange={this.props.ruleGroupsCountChange}
          showGetSQL={false}
        />
        <div className="query-apply-container">
          <span className="btn_custom pull-right" onClick={this.applyQueryAndHideTree}>
            Apply
          </span>
          {this.props.isQueryHeaderEdited && this.props.isQueryInteractionPermitted && (
            <span className="btn_custom pull-right btn-apply-save btn_custom_bg_red" onClick={this.applyAndSave}>
              Save & Apply
            </span>
          )}
        </div>
      </>
    )
  }
}

QueryBuilderTree.propTypes = {
  queryTree: PropTypes.object,
  handleQueryTreeChanged: PropTypes.func,
  fetchTypeChildren: PropTypes.func,
  isQueryHeaderEdited: PropTypes.bool,
  user: PropTypes.object,
  clearQueryTree: PropTypes.func,
  getQuerySQL: PropTypes.func,
  isQueryInteractionPermitted: PropTypes.bool,
  createMultipleRules: PropTypes.func,
  createAlert: PropTypes.func,
  querySQL: PropTypes.string,
  addCustomModal: PropTypes.func,
  querySQLLoading: PropTypes.bool,
  ruleGroupsCountChange: PropTypes.func,
  filters: PropTypes.object,
  toggleTreeVisibility: PropTypes.func,
  supraQCToolApplyQuerySamplingQC: PropTypes.func,
  sessionId: PropTypes.string
}

function mapStateToProps(state) {
  return {
    sessionId: state.supraQCToolV2.samplingQCTab.sessionId,
    queryTree: state.supraQCTool.queryTree,
    querySQL: state.supraQCTool.querySQL,
    querySQLLoading: state.supraQCTool.querySQLLoading,
    isQueryHeaderEdited: state.supraQCTool.isQueryHeaderEdited,
    isQueryInteractionPermitted: state.session.user
      ? UserService.hasPermission(state.session.user, PERMISSIONS.adminToolsQCToolQueryInteraction)
      : false,
    filters: state.supraQCTool.searchFilters
  }
}

export default connect(mapStateToProps, {
  handleQueryTreeChanged,
  fetchTypeChildren,
  clearQueryTree,
  createMultipleRules,
  createAlert,
  addCustomModal,
  supraQCToolApplyQuerySamplingQC
})(QueryBuilderTree)
